import React from "react";
import { useTranslation } from "react-i18next";

export default function Privacy() {
    const { t } = useTranslation();

    return (
        <div className="container py-5 mb-5" style={{ minHeight: "60vh" }}>
            <div className="card border-0 shadow-sm p-4 p-md-5">
                <h2 className="fw-bold text-primary mb-4">
                    <i className="bi bi-shield-lock me-2"></i>
                    {t("footer_pol_privacy")}
                </h2>
                <div className="text-muted lh-lg">
                    <h5 className="fw-bold text-dark mt-4">{t("privacy_1_title")}</h5>
                    <p>{t("privacy_1_desc")}</p>
                    
                    <h5 className="fw-bold text-dark mt-4">{t("privacy_2_title")}</h5>
                    <p>{t("privacy_2_desc")}</p>
                    
                    <h5 className="fw-bold text-dark mt-4">{t("privacy_3_title")}</h5>
                    <p>{t("privacy_3_desc")}</p>
                </div>
            </div>
        </div>
    );
}